import { MAIN_PRODUCT, PRODUCTS } from '@/app/app.constants';
import { getLocaleFromUrl } from '../plugins/i18n';

export function getProductNames(): { mainProduct: string; productName: string } {
  const [, , mainProduct] = window.location.pathname.split('/');

  const [, , , , productName] = window.location.pathname.split('/');

  // NOTE: у байполиси флоу отсуствует productName, поэтому он вернет название страницы
  if (!Object.values(PRODUCTS).find(item => item === productName)) {
    return { mainProduct, productName: PRODUCTS.CAR_INSURANCE };
  }

  return { mainProduct, productName };
}

function usePathWithLocale(locale: string) {
  return (path: string) => {
    let optimizedPath = path.startsWith('/') ? path.slice(1) : path;
    if (optimizedPath.endsWith('/')) optimizedPath = optimizedPath.slice(0, -1);
    return `/${locale}/${optimizedPath}`;
  };
}

export function getPathHead(mainProduct: string, productName: string) {
  const { locale } = getLocaleFromUrl();
  const getPathWithLocale = usePathWithLocale(locale);

  if (mainProduct === MAIN_PRODUCT) {
    return getPathWithLocale(`${mainProduct}/flow`);
  }

  return getPathWithLocale(`${mainProduct}/flow/${productName}`);
}
